<nz-date-picker [nzAllowClear]="true" [(ngModel)]="dashboardParams[parameter.Name]"
  [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged($event);" [nzFormat]="dateFormat">
</nz-date-picker>
<ng-template #tplRender let-current>
  <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
    {{ current.getDate() }}
  </div>
</ng-template>
